module.exports = __webpack_public_path__ + "media/img/apple-icon-144x144-22924af5947a677d08e335a7d44c9efe.png";